import { FC } from 'react'
import styles from 'components/features/pfm/KebabButton/KebabButton.styl'
import { Kebab } from 'components/features/pfm/Kebab/Kebab'

type KebabButtonProps = {
  onClick?: () => void
  expanded?: boolean
  hamburgerMode?: boolean
}

export const KebabButton: FC<KebabButtonProps> = (props) => {
  const { onClick, expanded, hamburgerMode } = props

  return (
    <button onClick={ onClick } className={ styles.kebabButton } title={ hamburgerMode ? 'Show Menu' : 'Show Comparisons' }>
      <Kebab expanded={ expanded } hamburgerMode={ hamburgerMode } />
    </button>
  )
}
